import React from 'react';

import { Text } from '@ekhodealer/ekho-common/rev';

import type { BlemishUploadTask } from '../../api/useBlemishImageUpload';

import CheckCircleFilled16 from '@common/components/icons/CheckCircleFilled16';

import './UploadStatusItem.scss';

const formatFileSize = (bytes: number): string => {
	if (bytes === 0) return '0 B';
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
	return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export interface UploadStatusItemProps {
	/** The upload task to display */
	task: BlemishUploadTask;
}

const SpinnerIcon = (): React.JSX.Element => (
	<svg
		className='upload-status-item__spinner'
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		aria-hidden='true'>
		<circle cx='8' cy='8' r='6' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeDasharray='28 10' />
	</svg>
);

const ErrorIcon = (): React.JSX.Element => (
	<svg width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
		<circle cx='8' cy='8' r='7' stroke='currentColor' strokeWidth='1.5' />
		<path d='M8 5v3.5M8 10.5v1' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
	</svg>
);


export const UploadStatusItem = ({ task }: UploadStatusItemProps): React.JSX.Element => {
	const { file, status } = task;

	return (
		<div className='upload-status-item' data-status={status}>
			<div className='upload-status-item__row'>
				<div
					className={`upload-status-item__status-icon${status === 'error' ? ' upload-status-item__status-icon--error' : ''}${status === 'success' ? ' upload-status-item__status-icon--success' : ''}`}>
					{status === 'uploading' && <SpinnerIcon />}
					{status === 'error' && <ErrorIcon />}
					{status === 'success' && <CheckCircleFilled16 />}
				</div>
				<div className='upload-status-item__name'>
					<Text size='bodySmall'>
						{file.name}
					</Text>
				</div>
				<div className='upload-status-item__size'>
					<Text size='bodySmall' color='secondary'>
						{formatFileSize(file.size)}
					</Text>
				</div>
			</div>
		</div>
	);
};
